import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  switch: true,
};

export const languageSlice = createSlice({
  name: "currentLanguage",
  initialState,
  reducers: {
    switchLanguage: (state, actions) => {
      state.switch = !state.switch;
    },
  },
});

export const { switchLanguage } = languageSlice.actions;

export default languageSlice.reducer;
